export default __webpack_public_path__ + "static/media/Rune Stone of the Royal Stables.0758600d.jpg";